import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import FollowerGoalSettingsPopoutApp from './FollowerGoalSettingsPopoutApp.vue';
import PipiPupuAPIClient from './PipiPupuAPIClient';
import PipiPupuAuth from './PipiPupuAuth';
import ChatSocket from './ChatSocket';
import 'allsettled-polyfill';

Vue.prototype.$baseUrl = process.env.VUE_APP_PIPIPUPUBASE || `${location.protocol}//${location.host}`;
Vue.prototype.$auth = new PipiPupuAuth();
Vue.prototype.$api = new PipiPupuAPIClient(`${process.env.VUE_APP_PIPIPUPUBASE||''}/api`, Vue.prototype.$auth);
Vue.prototype.$socket = new ChatSocket(`${process.env.VUE_APP_PIPIPUPUSOCKETBASE}/api/socket`);
new Vue({ render: h => h(FollowerGoalSettingsPopoutApp) }).$mount('#app');
